export default __webpack_public_path__ + "static/media/gallery-5.0d9c8844.jpg";